function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "14.25,13.594 8.656,13.594 8.656,8 5.844,8 5.844,13.594 0.25,13.594 0.25,16.406 5.844,16.406  5.844,22 8.656,22 8.656,16.406 14.25,16.406 "
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#333333",
  cx: 32,
  cy: 7.5,
  r: 7.5
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M40.533,30H23.467c-3.107,0-5.217-1.895-5.217-5.059c0-4.414,1.035-11.191,6.76-11.191 c0.604,0,3.16,2.715,6.99,2.715s6.387-2.715,6.99-2.715c5.724,0,6.76,6.777,6.76,11.191C45.75,28.105,43.641,30,40.533,30z"
});

var SvgNewOrgIcon = function SvgNewOrgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "46px",
    height: "30px",
    viewBox: "0 0 46 30",
    enableBackground: "new 0 0 46 30",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewOrgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_org_icon.a3133aec.svg";
export { ForwardRef as ReactComponent };